<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="close" v-on:click="close()"></div>
      <div class="modalContent" v-if="video">
        <iframe v-if="video.mimetype === 'video/youtube'"
          :src="video.embedUri"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media;
          gyroscope; picture-in-picture"
          allowfullscreen></iframe>
        <VuePlyr ref="video" :options="{ hideControls: false }" v-else>
          <video></video>
        </VuePlyr>
      </div>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  name: 'videoDialog',
  components: { VuePlyr },
  data() {
    return {
      show: false,
      video: null,
    };
  },
  methods: {
    open(video) {
      this.video = video;
      this.show = true;
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      if (video.mimetype === 'video/youtube') {
        this.video.embedUri += video.embedUri.indexOf('?') >= 0 ? '&autoplay=1' : '?autoplay=1';
      } else {
        const src = [];
        if (video.vid1080p) src.push({ src: video.vid1080p, type: 'video/mp4', size: 1080 });
        if (video.vid720p) src.push({ src: video.vid720p, type: 'video/mp4', size: 720 });
        if (video.vid480p) src.push({ src: video.vid480p, type: 'video/mp4', size: 480 });
        if (video.vid360p) src.push({ src: video.vid360p, type: 'video/mp4', size: 360 });
        setTimeout(() => {
          const v = this.$refs.video.player;
          v.source = { type: 'video', title: video.name, sources: src };
          v.play();
        });
      }
    },
    close() {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      background-color: #eee;
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .close{
      width: 46px; height: 46px;
      // border-radius: 50%;
      position: absolute;
      right: 20px; top: 20px;
      background-image: url(../assets/close.png);
      background-color: #ddd;
      background-size: 18px auto;
      border-radius: 50%;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 91;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        // background-image: url(../assets/close-white.png);
        background-color: #ccc;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
    }
    .modalContent{
      z-index: 2;
      // border-radius: 10px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 980px;
      line-height: 1;
      // background-color: #1d449d;
      // padding: 5px;
      border-radius: 7px;
      // box-shadow: 5px 5px 0 #fae502;
      @media (max-width: 1024px) {
        width: calc(100% - 20px);
        margin: 0 10px;
        text-align: center;
        padding: 0;
      }
      iframe{
        width: 100%; height: 580px;
        display: block;
        @media (max-width: 1024px) {
          height: 74vw;
        }
      }
    }
  }
</style>
